import React from 'react';
import escape from 'lodash/escape';
import { Button, Iconfont } from '@umu/umu-design';
import * as imageUtil from '@umu/umu-image-handle';
import { classSet, openWindow } from '@umu/umu-dom';
import { If } from 'common/src/components';
import { IStatLogParams } from '@umu/umu-api/src/services/api/achievement/statLogDialog';
import './index.scss';

enum CONTENT_RULE_TYPE {
    LINK = 1, // 链接
}
interface IContentRule {
    key: string;
    type: CONTENT_RULE_TYPE;
    value: string;
    color: string;
    link: string;
    style?: React.CSSProperties;
}
interface IOfficialButtonItem {
    link: string;
    label: string;
    spaceCount?: number;
    status: 0 | 1;
    type: {
        app: string;
        pc:
            | 'link'
            | 'text'
            | 'default'
            | 'primary'
            | 'primary-blue'
            | 'ghost'
            | 'ghost-blue'
            | 'ghost-grey'
            | 'text-grey'
            | 'dark-mode';
    };
    params: Record<string, string>;
}
interface IOfficialPopupContent {
    text: string;
    config: {
        rule_list: IContentRule[];
    };
}
interface IOfficialPopup {
    id: string;
    dialog_title: string;
    button_list: IOfficialButtonItem[];
    display_content: IOfficialPopupContent;
    display_img_url: string;
    display_title: string;
    params: Record<string, string>;
}
interface IProps {
    heardTitle: string;
    title: string;
    contentImg: string;
    content: string;
    buttonList: IOfficialButtonItem[];
    onFooterBtnClick: (item: IOfficialButtonItem) => void;
    onCloseBtnClick: VoidFunction;
}
const getRegElement = (item: IContentRule): string => {
    const { type, value = '', style, color, link } = item;
    switch (type) {
        case CONTENT_RULE_TYPE.LINK:
            const styleStr = Object.entries(style || { color })
                .map(([key, value]) => `${key}:${value}`)
                .join(';');
            // eslint-disable-next-line react/jsx-no-target-blank
            return `<a style="text-decoration:none;${styleStr}" href="${link}" target="_blank">${value}</a>`;
        default:
            return '';
    }
};
const onTransformText = (content: IOfficialPopupContent) => {
    const {
        text,
        config: { rule_list = [] },
    } = content;
    let html = escape(text).replace(/\n/g, '<br/>');
    rule_list.forEach((item) => {
        if (item.key !== '') {
            const regEle = getRegElement(item);
            html = html.replace(item.key, regEle);
        }
    });
    return html;
};
const getBtnList = (buttonList: IOfficialButtonItem[]) => {
    return buttonList.filter((item) => Number(item.status) === 1 && item.label !== '');
};
const getOfficialPopupConfig = (
    data: IOfficialPopup,
    info: {
        logServer: (params: IStatLogParams) => any;
        callBack: VoidFunction;
        onCloseDialog: VoidFunction;
    },
) => {
    const { id, dialog_title = '', button_list = [], display_content, display_img_url = '', display_title = '' } = data;
    const { callBack, onCloseDialog, logServer } = info;
    callBack && callBack();
    return {
        heardTitle: dialog_title,
        title: display_title,
        contentImg: imageUtil.appendWidth(display_img_url),
        content: onTransformText(display_content) || '',
        buttonList: getBtnList(button_list),
        onFooterBtnClick: (item: any) => {
            onCloseDialog();
            id && logServer && logServer(Object.assign({ action_type: id }, item.params));
            item.link && openWindow(item.link, '_self');
        },
        onCloseBtnClick: () => {
            onCloseDialog();
        },
    };
};
const OfficialPopup = (props: IProps) => {
    const { heardTitle, title, contentImg, content, buttonList = [], onFooterBtnClick, onCloseBtnClick } = props;
    const renderFooterBtn = () => {
        const list = buttonList.filter((item) => Number(item.status) === 1 && item.label !== '');
        const len = list.length;
        return list.map((item, index) => {
            const isLast = index === list.length - 1;
            return (
                <Button
                    key={index}
                    onClick={() => onFooterBtnClick(item)}
                    type={item.type.pc}
                    className="footer-btn"
                    style={{
                        marginRight: `${isLast ? 0 : item.spaceCount || 0}px`,
                        maxWidth: `calc(${100 / len}% - ${len * (item.spaceCount || 2)}px)`,
                    }}
                >
                    {item.label}
                </Button>
            );
        });
    };
    return (
        <div className="official-dialog-info official-dialog-info-mobile">
            <div className="official-dialog-title">
                <span>{heardTitle}</span>
                <Iconfont className="official-dialog-title-icon" type="Close" onClick={onCloseBtnClick} />
            </div>
            <div className="official-dialog-body">
                <div className="heard-info">{title}</div>
                <div className="content-body-info">
                    <If condition={contentImg !== ''}>
                        <img className="img-info" src={contentImg} />
                    </If>
                    <If condition={content !== ''}>
                        <div
                            className="content-info"
                            dangerouslySetInnerHTML={{
                                __html: content,
                            }}
                        />
                    </If>
                </div>
                <If condition={buttonList.length > 0}>
                    <div
                        className={classSet({
                            'footer-info': true,
                            'footer-info-no-content': content === '' || contentImg === '',
                        })}
                    >
                        {renderFooterBtn()}
                    </div>
                </If>
            </div>
        </div>
    );
};

export { IOfficialPopup, OfficialPopup, getOfficialPopupConfig };
